import { createIcon } from '@chakra-ui/react'

export const TriangleExclamationIcon = createIcon({
  displayName: 'TriangleExclamationIcon',
  viewBox: '0 0 32 32',
  path: (
    <path fillRule='evenodd' clipRule='evenodd' d='M18.6476 5.53508C17.5259 3.48831 14.4741 3.48831 13.3524 5.53508L3.3484 23.7886C2.29977 25.7019 3.74457 28 5.99601 28H26.004C28.2554 28 29.7002 25.7019 28.6516 23.7886L18.6476 5.53508ZM14.05 16.8038C14.05 17.7551 14.7775 18.5263 15.675 18.5263C16.5725 18.5263 17.3 17.7551 17.3 16.8038V12.6699C17.3 11.7186 16.5725 10.9474 15.675 10.9474C14.7775 10.9474 14.05 11.7186 14.05 12.6699V16.8038ZM15.6783 23.5789C16.5739 23.5789 17.3 22.872 17.3 22C17.3 21.128 16.5739 20.4211 15.6783 20.4211H15.6717C14.7761 20.4211 14.05 21.128 14.05 22C14.05 22.872 14.7761 23.5789 15.6717 23.5789H15.6783Z' fill='currentColor' />
  ),
})
